// extracted by mini-css-extract-plugin
export default {"container":"Content_container__-I11a","burger":"Content_burger__7hJS8"};